import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import GameListInterface from '../../api/GameListInterface';
import AppBackgroundType from '../../utils/AppBackgroundType';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import Screens from '..';
import RouteParamConstants from '../../utils/routeParamConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
export var PAGE_SIZE = 8;

var Favourites = /*#__PURE__*/function (_Component) {
  _inherits(Favourites, _Component);

  var _super = _createSuper(Favourites);

  function Favourites() {
    var _this;

    _classCallCheck(this, Favourites);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};
    _this._fetchFavourites = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fetchedFavGames, favouriteGames, _QueryParamsProxy$set;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return GameListInterface.getFavGames();

            case 2:
              fetchedFavGames = _context.sent;
              favouriteGames = transformObjectArrayResponse(fetchedFavGames.FAVOURITE_GAMES);

              _this._getFavPanelList(favouriteGames);

              _this.props.setFavouriteGames(favouriteGames);

              if (fetchedFavGames.MESSAGE !== null) {
                QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MODAL, Screens.FavouritesExpired), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MSG, fetchedFavGames.MESSAGE), _QueryParamsProxy$set));
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this._getFavPanelList = function (rawFavourites) {
      var _this$props = _this.props,
          vipGames = _this$props.vipGames,
          slotGames = _this$props.slotGames,
          tableGames = _this$props.tableGames;
      var parsedVipGames = vipGames.gameList[0] ? vipGames.gameList[0].games : [];
      var parsedSlotGames = slotGames.gameList[0] ? slotGames.gameList[0].games : [];
      var parsedTableGames = tableGames.gameList[0] ? tableGames.gameList[0].games : [];
      var allGames = [].concat(_toConsumableArray(parsedVipGames), _toConsumableArray(parsedSlotGames), _toConsumableArray(parsedTableGames));
      var rawFavouriteIds = rawFavourites.map(function (fav) {
        return fav.game_id;
      });
      var panelList = allGames.filter(function (game) {
        return rawFavouriteIds.includes(game.GAME_ID) && !game.IS_HIDDEN;
      });
      var pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (currentPage, index) {
        return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
      });
      var pageNumber = 0;
      pagedGames.forEach(function (page, index) {
        if (page.find(function (game) {
          return game.UNLOCKED === 'true';
        })) {
          pageNumber = index;
        }
      });

      _this.setState({
        panelList: panelList,
        pagedGames: pagedGames,
        pageNumber: pageNumber
      });
    };

    _this._itemClickHandler = function (id) {
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Game, {
        gid: id
      });
    };

    return _this;
  }

  _createClass(Favourites, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setAppBackground(AppBackgroundType.FAVOURITES);

      this._fetchFavourites();

      Logger.sendEvent(EVENT_TYPES.GAME_ROOM_LOADED, {
        name: 'favorites'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.favouriteGames.gameList.length !== prevProps.favouriteGames.gameList.length) {
        this._fetchFavourites();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setAppBackground(AppBackgroundType.NORMAL);
    }
  }, {
    key: "render",
    value: function render() {
      var pagedGames = this.state.pagedGames;
      var _this$props2 = this.props,
          render = _this$props2.render,
          lobbyPromotions = _this$props2.lobbyPromotions;
      return render({
        itemClick: this._itemClickHandler,
        lobbyPromotions: lobbyPromotions,
        pagedGames: pagedGames,
        pageNumber: 0 // Initial page for the Favourites room should always be the first

      });
    }
  }]);

  return Favourites;
}(Component);

export { Favourites as default };